import { EventOwner } from '@/pages/admin/event_owners/index.page'
import { DefaultOwnerIcon } from '@/components/icons/EventsIcons'
import Tooltip from '@/components/Tooltip'

interface OwnerAvatarGroupProps {
  owners: EventOwner[]
  maxDisplay?: number
  onClick?: () => void
  editable?: boolean
}

const bgColors = ['#EB1964', '#F26B3A', '#3AA5F2', '#FFC299']

export function OwnerAvatarGroup({
  owners,
  maxDisplay = 3,
  onClick,
  editable = true,
}: OwnerAvatarGroupProps) {
  // Get the names of owners not displayed (for tooltip)
  const hiddenOwners = owners.slice(maxDisplay)
  const hiddenOwnerNames = hiddenOwners.map((owner) => owner.name).join(', ')

  const content =
    owners.length > 0 ? (
      <div className="flex items-center">
        {owners.slice(0, maxDisplay).map((owner, index) => (
          <div
            key={owner.id}
            className={`w-6 h-6 rounded-full text-white flex items-center justify-center text-xs ${
              index > 0 ? '-ml-1' : ''
            }`}
            style={{ backgroundColor: bgColors[index % bgColors.length], zIndex: 10 - index }}
          >
            {owner.name.charAt(0).toUpperCase()}
          </div>
        ))}
        {owners.length > maxDisplay && (
          <Tooltip title={hiddenOwnerNames} placement="top">
            <div
              className="w-6 h-6 rounded-full flex items-center justify-center text-xs -ml-1 cursor-pointer"
              style={{ backgroundColor: '#FFC299', color: '#F26B3A', zIndex: 10 - maxDisplay }}
            >
              +{owners.length - maxDisplay}
            </div>
          </Tooltip>
        )}
      </div>
    ) : (
      <DefaultOwnerIcon />
    )

  return (
    <div
      className={editable ? 'cursor-pointer' : ''}
      onClick={editable ? onClick : undefined}
    >
      {content}
    </div>
  )
}
